export default "__VITE_ASSET__760c31c8__"